import { createRouter, createWebHistory } from 'vue-router';

const routes = [
  { path: '/', name: 'Home', component: () => import('../views/home.vue') },
  { path: '/contact', name: 'Contact', component: () => import('../views/contactUs.vue') },
  { path: '/about', name: 'About', component: () => import('../views/about.vue') },
  { path: '/business', name: 'Business', component: () => import('../views/business.vue') },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 始终滚动到顶部
    return { top: 0 }
    // 或者平滑滚动（支持浏览器原生滚动行为）
    // return { top: 0, behavior: 'smooth' }
  }
});


export default router;